import { useQuery } from "react-query";
import { API_BASE } from "../../constants/constants";
import { PortfolioReportsApi } from "@iliotech/generated-api-v3";

export const useFutureScenarioIncome = (
  portfolioId: string,
  enabledCondition: boolean,
  nextMonths?: number
) => {
  const api = new PortfolioReportsApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`portfolio-future-income`, { portfolioId, nextMonths }],
    () => api.getPortfolioFutureIncome(portfolioId, nextMonths),
    {
      enabled: enabledCondition && !!nextMonths,
    }
  );
};
